<script>
/* eslint-disable indent */

  export default {
    name: 'Promise',
    props: {
      value: null,
      promise: {
        validator: function (p) {
          return (p && typeof p.then === 'function' && typeof p.catch === 'function')
        }
      },
      transform: {
        type: Function,
        default: response => response
      }
    },
    data: function () {
      return {
        pending: false,
        success: false,
        error: false
      }
    },
    computed: {
      response: {
        get: function () {
          return this.value
        },
        set: function (value) {
          this.$emit('input', value)
        }
      },
      status: function () {
        return {
          pending: this.pending,
          success: this.success,
          error: this.error
        }
      }
    },
    watch: {
      pending: function (value) {
        this.$emit('update:pending', value)
      },
      success: function (value) {
        this.$emit('update:success', value)
      },
      error: function (value) {
        this.$emit('update:error', value)
      },
      status: function (value) {
        this.$emit('update:status', value)
      },
      promise: {
        handler: function (promise, old) {
          this.abort(old)

          if (promise) {
            this.pending = true
            promise
              .then(this.transform)
              .then(response => {
                if (promise === this.promise) {
                  this.response = response
                  this.success = true
                  this.error = false
                }
              })
              .catch(error => {
                if (promise === this.promise) {
                  this.success = false
                  this.error = error
                }
              })
              .finally(() => {
                if (promise === this.promise) {
                  this.pending = false
                }
              })
          }
        },
        immediate: true
      }
    },
    methods: {
      abort: function (promise) {
        if (promise) {
          if (typeof promise.cancel === 'function') {
            promise.cancel()
          }
        }
      }
    },
    render: function () {
      return this.$scopedSlots.default ? this.$scopedSlots.default({
        pending: this.pending,
        success: this.success,
        error: this.error,
        response: this.response
      }) : this.$slots.default
    },
    beforeDestroy: function () {
      this.abort(this.promise)
    }
  }
</script>
